module.exports = __webpack_public_path__ + "static/media/kanna-min.9e6a0ab3.png";